import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import InterestedPage from "@/pages/InterestedPage";
import WaitlistConfirmedPage from "@/pages/WaitlistConfirmedPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/interested" element={<InterestedPage />} />
          <Route path="/waitlist-confirmed" element={<WaitlistConfirmedPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
